import { c as _c } from "react/compiler-runtime";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SvgIcon from '@mui/material/SvgIcon';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { styled } from '@classify/react-core-components/styles';
import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';
const ButtonStyled = styled(Button)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  '&&': {
    border: `1px solid ${palette.interaction.border}`,
    backgroundColor: palette.layout.background.navigation,
    padding: spacing(0, 2),
    minHeight: 75,
    width: '100%',
    color: palette.text.onMain
  },
  '& .MuiButton-startIcon + span': {
    flexGrow: 1,
    textAlign: 'left'
  },
  '& .MuiButton-startIcon .MuiSvgIcon-root': {
    width: 24,
    height: 24
  },
  '& .MuiButton-endIcon .MuiSvgIcon-root': {
    width: 24,
    height: 24
  }
})) as typeof Button;
interface Props {
  children: string;
  iconComponent: typeof SvgIcon;
  onClick?: () => void;
  href?: string;
  subTitle?: string;
  'data-event'?: string;
}
export default function ContactChannelButton(t0) {
  const $ = _c(19);
  const {
    children,
    subTitle,
    iconComponent: Icon,
    onClick: t1,
    href,
    "data-event": dataEvent
  } = t0;
  const onClick = t1 === undefined ? _temp : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      pr: 1
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== Icon) {
    t3 = <Icon sx={t2} />;
    $[1] = Icon;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== href) {
    t4 = href ? <OpenInNewIcon fontSize="medium" /> : <ChevronRightIcon />;
    $[3] = href;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children) {
    t5 = <Typography variant="h5" component="div">{children}</Typography>;
    $[5] = children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== subTitle) {
    t6 = subTitle && <Typography variant="body" component="div">{subTitle}</Typography>;
    $[7] = subTitle;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== dataEvent || $[13] !== href || $[14] !== onClick || $[15] !== t3 || $[16] !== t4 || $[17] !== t7) {
    t8 = <><ButtonStyled href={href} startIcon={t3} endIcon={t4} variant="tertiary" onClick={onClick} target="_blank" data-event={dataEvent}>{t7}</ButtonStyled></>;
    $[12] = dataEvent;
    $[13] = href;
    $[14] = onClick;
    $[15] = t3;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
function _temp() {}